export const toCamelcase = (text) => {
    text = text.replace(/[-_\s.]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''));
    return text.substr(0, 1).toLowerCase() + text.substr(1);
};
export const objectKeysToCamelcase = (obj) => {
    return Object.entries(obj).reduce((p, c) => (Object.assign(Object.assign({}, p), { [toCamelcase(c[0])]: c[1] })), {});
};
export const deepObjectKeysToCamelcase = (obj) => {
    const recurObjectKeysToCamelcase = (objOrArray) => {
        const typeOfObjOrArray = typeof objOrArray;
        if (Array.isArray(typeOfObjOrArray))
            return objOrArray.map(recurObjectKeysToCamelcase);
        if (typeOfObjOrArray === 'object' && objOrArray !== null)
            return deepObjectKeysToCamelcase(objOrArray);
        return objOrArray;
    };
    if (Array.isArray(obj))
        return obj.map(recurObjectKeysToCamelcase);
    return Object.entries(obj).reduce((p, c) => (Object.assign(Object.assign({}, p), { [toCamelcase(c[0])]: recurObjectKeysToCamelcase(c[1]) })), {});
};
//# sourceMappingURL=to-camelcase.js.map